import { render, staticRenderFns } from "./Deliveries.vue?vue&type=template&id=51e8a884&scoped=true"
import script from "./Deliveries.vue?vue&type=script&lang=js"
export * from "./Deliveries.vue?vue&type=script&lang=js"
import style0 from "./Deliveries.vue?vue&type=style&index=0&id=51e8a884&prod&lang=css"
import style1 from "./Deliveries.vue?vue&type=style&index=1&id=51e8a884&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8a884",
  null
  
)

export default component.exports